import { render, staticRenderFns } from "./markdown.vue?vue&type=template&id=417823a0&"
import script from "./markdown.vue?vue&type=script&lang=ts&"
export * from "./markdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports